<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';
 
   export default {
      page: {
         title: "Cancelled Consultations",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const current_date = moment().format("YYYY-MM-DD");

         return {
            title: "Doctor Leave Consultations",
            items: [
               {
                  text: "Consultations",
                  href: "/consultations",
               },   
               {
                  text: "Doctor Leave Consultations",
                  active: true,
               },                   
            ],

            consultations: [],           
            pagination: {},
            keyword: "",
            showsearch: false,
            listing_length: 10,
            consultation_status: 'today',
            doctor_id: '',
            token: "",
            errors: {},          
            active_page_url: null,
            cancelled_by: "",
            today: current_date,
            cancel_consultation: {
               id: "",
               reason: "",
         },

         };
      },
      mounted() {
         this.clearLocalStorage();

      },

      created() {
         const savedFilters = localStorage.getItem("cancel_consultation_filters");

         if (savedFilters) {
            const filters = JSON.parse(savedFilters);

            // Restore values
            this.keyword = filters.keyword || "";
            this.listing_length = filters.listing_length || 10;
            this.cancelled_by = filters.cancelled_by || "";
            this.active_page_url = filters.active_page_url || null;

            // Clear stored filters
            localStorage.removeItem("cancel_consultation_filters");

            // Fetch consultations using restored filters
            this.fetchConsultation(this.active_page_url);
         } else {
            this.fetchConsultation(); // Load normally if no stored filters
         }
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");
         },

         getDetailsRoute(id) {
            const filters = {
               keyword: this.keyword,
               listing_length: this.listing_length,
               cancelled_by: this.cancelled_by,
               active_page_url: this.active_page_url || this.$route.fullPath, // Store last visited page
            };
            localStorage.setItem("cancel_consultation_filters", JSON.stringify(filters)); // Save filters
            this.$router.push({ name: "consultations.details", params: { id: id } });
         },

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchConsultation(page_url) {
            let url = "api/admin/cancelled-consultations?limit=" + this.listing_length + "&status=" + this.cancelled_by + "&keyword=" + this.keyword;         
            this.getToken();
            page_url = page_url || url;

            this.active_page_url = page_url;
            this.loading = true;
            this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.consultations = responseData.cancel_consultations.data;  
               console.log(this.consultations);
          
               this.pagination = responseData.cancel_consultations.links;
               this.from = responseData.cancel_consultations.from;
               this.to = responseData.cancel_consultations.to;
               this.total = responseData.cancel_consultations.total;             
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },
         // cancelConsultation(booking_id) {
         //    this.delete = false;
         //    this.$bvModal.msgBoxConfirm('Are you sure you want to cancel this booking?', {
         //          title: 'Confirm',
         //          size: 'sm',
         //          buttonSize: 'sm',
         //          okVariant: 'danger',
         //          okTitle: 'Yes',
         //          cancelTitle: 'No',
         //          footerClass: 'p-2',
         //          hideHeaderClose: false,
         //          centered: true
         //    })
         //    .then(value => {
         //       this.delete = value
         //       if(this.delete){
         //          this.getToken();           
            
         //          const config = {
         //             headers: {
         //                "Content-type": "application/json",
         //                "Accept": "application/json",
         //                "Authorization": "Bearer " + this.token,
         //             },
         //          };
                 
         //          let url = "api/admin/consultations/cancel_leave?booking_id=" + booking_id;
         //          this.$axios
         //          .get(url, config)
         //          .then((response) => {
         //                if (response.data.status) {
         //                   this.$swal("", response.data.message, "success");
         //                } else {
         //                   this.$swal("", response.data.message, "error");
         //                }
         //                this.fetchConsultation(this.active_page_url);
         //          })
         //          .catch((error) => {
         //             if (error.response) {
         //                if (error.response.data.message) {
         //                   this.errors = error.response.data.message;
         //                   //console.log(this.errors);
         //                } else {
         //                   this.$swal("", "Something went wrong", "error");
         //                }
         //             } else {
         //                this.$swal("", "Something went wrong", "error");
         //             }
         //          })
         //          .finally(() => (this.loading = false));
         //       }
         //    })
         //    .catch(err => {
         //       console.log(err);
         //    })
         // },
         cancelModal(consultation){
            
            this.cancel_consultation.id = consultation.id;
            this.showModal("cancel-modal");
         }, 

         cancelConsultation() {
   
            this.getToken();           

            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/consultations/cancel_leave?booking_id=" + this.cancel_consultation.id + "&reason=" + this.cancel_consultation.reason;
            this.$axios
            .get(url, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchConsultation(this.active_page_url);
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     //console.log(this.errors);
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));

         },

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-3">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchConsultation()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-9">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchConsultation()"/>
                           </label>
                        </div>  
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="cancelled_by" @change="fetchConsultation()">
                                 <option value="">By Any</option>
                                 <option value="1">By Admin</option>
                                 <option value="4">By Clinic</option>
                                 <option value="2">By Doctor</option>
                                 <option value="3">By User</option>
                              </select>
                           </label>
                        </div>                    
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th width="15%">User</th> 
                              <th>Patient</th>             
                              <th width="20%">Doctor</th>   
                              <!-- <th width="5%">Token</th> -->
                              <th width="20%">Booking Date & Slot, Token</th> 
                              <th>Type</th> 
                              <th width="15%">Created By & Created On</th>
                              <th width="15%">Cancelled by & Cancelled on</th>
                              <th width="20%">Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(consultations.length)">
                           
                           <tr v-for="consultation in consultations" :key="consultation.id">
                              <td>{{consultation.name}}<br>{{consultation.country_code}} {{consultation.mobile}}</td> 
                              <td>
                                 <span v-if="consultation.member_id">{{ consultation.member_name }}</span>
                                 <span v-else>Self</span>
                              </td>                   
                              <span v-if="consultation.doctor"><span v-if="consultation.doctor.prefix == 1">Dr. </span><span v-else-if="consultation.doctor.prefix == 2">Mr. </span><span v-else-if="consultation.doctor.prefix == 3">Ms. </span> {{consultation.doctor.name}}</span>
                              <!-- <td></td>  -->                
                              <td>
                                 <span v-if="consultation.rescheduled_id">Rescheduled <br></span>
                                 {{ consultation.booking_date|formatDate }}<br>{{ consultation.consultation_start|formatTime }} - {{ consultation.consultation_end|formatTime }}<br>
                                 Token: {{ consultation.token }}
                              </td>
                              
                              
                              <td>
                                 <span v-if="consultation.consultation_type == 1">Video</span>
                                 <span v-if="consultation.consultation_type == 2">Home</span>
                                 <span v-if="consultation.consultation_type == 3">Clinic</span>
                              </td>
                              
                                                           
                              <td>
                                 <span v-if="consultation.added_by==1">Patient</span>
                                 <span v-if="consultation.added_by==2">Admin</span>
                                 <span v-if="consultation.added_by==3">Clinic</span>
                                 <!-- <span v-if="consultation.added_by==4">Clinic</span><br> -->
                                 <br>{{ consultation.converted_created_at }}
                              </td>
                             
                              <td>
                                 <span v-if="consultation.cancelled_status ==1">Pending</span>
                                 <span v-else>
                                    <span v-if="consultation.cancel_by == 1">Admin</span>
                                    <span v-if="consultation.cancel_by == 2">Doctor</span>
                                    <span v-if="consultation.cancel_by == 3">Patient</span>
                                    <span v-if="consultation.cancel_by == 4">Clinic</span>
                                    <br>

                                 {{ consultation.cancelled_at|formatDateTime }}
                                 </span>
                                 
                              </td>

                              <td>
                                 <!-- <router-link :to="{ name: 'consultations.details', params: { id: consultation.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link> -->
                                 <button  @click="getDetailsRoute(consultation.id)" class="btn btn-primary me-2 mb-2 btn-sm" type="button" >Details</button>
                                 <!-- <button class="btn btn-warning me-2 mb-2 btn-sm" type="button">Reschedule</button> -->
                                 <router-link :to="{ name: 'consultations.reschedule', params: {id: consultation.id,  doctor_id: consultation.doctor_id, patient_id: consultation.patient_id, type: consultation.consultation_type, clinic_id: consultation.clinic_id} }"  v-if="consultation.cancelled_status ==1"  class="btn btn-warning me-2 mb-2 btn-sm">Reschedule</router-link>
                                 <!-- <span v-if="consultation.cancelled_status == 3" class="btn btn-success me-2 mb-2 btn-sm">Rescheduled</span> -->
                                 <!-- <span v-if="consultation.cancelled_status == 1" @click="cancelConsultation(consultation.id)" class="btn btn-success me-2 mb-2 btn-sm">Cancel</span> -->
                                 <button @click="cancelModal(consultation)" class="btn btn-danger me-2 mb-2 btn-sm" type="button" v-if="consultation.cancelled_status == 1">Cancel</button>

                              </td>
                           </tr>

                 
                        </tbody>

                        <tbody v-else>
                           <tr>
                              <td colspan="7" class="text-center">No consultations found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption v-if="Boolean(consultations.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchConsultation(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + cancelled_by )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

                  <!---- modal starts ---->
                    <!---- modal starts ---->
        <b-modal ref="cancel-modal" id="cancel-modal" title="Cancel Consultation" hide-footer>
                     <b-form @submit.prevent="cancelConsultation()" >
                        
                        <b-col md="12" class="form-group">
                           <label class="control-label">Reason for Cancellation</label>
                           <textarea class="form-control" rows="4" v-model="cancel_consultation.reason"></textarea>
                        </b-col>                      
                        
                        <b-col md="12">
                           <b-button type="submit" class="me-3" variant="primary" @click="hideModal('cancel-modal')">Save</b-button>
                           <b-button class="" variant="light" @click="hideModal('cancel-modal')">Close</b-button>
                        </b-col>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
